<template>
    <div id="plannerapprove">
        <div class="container" style="margin-top: 10px;">
            <div class="row header mb-12">
                <div class="col-lg-12">
                    <h3 class="text-left mb-3">
                        Planner Approver
                    </h3>
                </div>
            </div>
            <div class="pb-5">
                <div class="row">
                    <div class="col-lg-6">
                        <div>
                            <h3>Planner List</h3>
                        </div>
                        <div v-if="assignedPlannerList.length>0">
                            <data-tables :data="assignedPlannerList">
                                <el-table-column v-for="item in assignedPlanner" :prop="item.prop"
                                                 :label="item.label" :key="item.prop"
                                                 sortable="custom">
                                </el-table-column>
                            </data-tables>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div v-if="approverComment.length>0">
                            <div>
                                <h3>Comments</h3>
                            </div>
                            <div v-for="item in approverComment">
                                <div class="divComment">
                                    <label>{{item.AppComDesc}} {{item.CONname}} on {{item.AppComCreatedDate_convert}}</label>
                                    <label>{{item.AppComValue}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="approverAction">
                    <div class="col-lg-12">
                        <label>Comment for other level planner</label>
                        <input type="text" class="form-control" v-model="inputCommentApprover">
                    </div>
                    <div class="col-lg-12">
                        <el-button type="primary" class="mt-2 mb-2" @click="approverStudentPlanner('Approved')">
                            Approve
                        </el-button>
                        <el-button type="primary" class="mt-2 mb-2" @click="approverStudentPlanner('Rejected')">
                            Reject
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DataSource from "../data/datasource";

    export default {
        name: "PlannerApprove",
        data() {
            return {
                plannerApproverID: '',
                approverAction: false,
                inputCommentApprover: '',

                approverComment: [],

                assignedPlannerList: [],
                assignedPlanner: [{
                    prop: 'PlnStaDomain',
                    label: "Domain"
                }, {
                    prop: "PlnStaIndicator",
                    label: "Indicator"
                }, {
                    prop: "OtherLevel",
                    label: "OtherLevel"
                }],
            };
        },
        async created() {
            if (this.$route.params.plannerApproverID === '' || this.$route.params.plannerApproverID === null || this.$route.params.plannerApproverID === undefined) { //this is from email link
                this.$router.push('/PendingApprover');

                // this.plannerApproverID = 'PLAA202000000381 ';
                // this.init();
            } else {
                this.plannerApproverID = this.$route.params.plannerApproverID;
                this.init();
            }
        },
        methods: {
            async getStudentPlannerDetails() {
                try {
                    let result = [];

                    const response = await DataSource.shared.getPlannerAssignedStudentDetails('Pending', '', '', '', '', this.plannerApproverID);
                    if (response) {
                        if (response.code === '2') {
                            console.log('getPlannerAssignedStudentDetails no record');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPlannerAssignedStudentDetails error');
                        } else {
                            this.assignedPlannerList = response.Table;
                        }
                    }

                    return result;
                } catch (e) {
                    this.results = e;
                }
            },
            async getApproverComment() {
                try {
                    const response = await DataSource.shared.getApproverComment(this.plannerApproverID);
                    if (response) {
                        this.approverComment = response.Table;
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async checkApprover() {
                try {
                    const response = await DataSource.shared.checkApproveStatusByUser(this.plannerApproverID, "PLANNER");
                    if (response) {
                        if (response.code === '1') {
                            this.approverAction = true;
                        } else {
                            this.approverAction = false;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async approverStudentPlanner(actionStatus) {
                try {
                    if (this.inputCommentApprover === '') {
                        this.$notify({
                            title: 'Required',
                            message: 'Required Comment....'
                        });
                    } else {
                        this.$vs.loading();

                        const response = await DataSource.shared.approvePlanner(actionStatus,  this.plannerApproverID, this.inputCommentApprover);
                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Approve Planner Assign Student: ERROR!!'
                                });
                            } else {
                                this.$notify({
                                    title: 'Successfully',
                                    message: 'Successfully Submit...'
                                });

                                window.location.replace('/PendingApprover');
                            }
                        }

                        this.$vs.loading.close();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            init() {
                this.getStudentPlannerDetails();
                this.getApproverComment();
                this.checkApprover();
            },
        },
    }
</script>

<style scoped>
    .divComment {
        padding: 10px;
        background-color: white;
        margin-bottom: 10px;
        border: 2px solid white;
        border-radius: 15px;
    }
</style>